export default __webpack_public_path__ + "static/media/africastalking.71b7625f.svg";